export const isLoadingDeviceTypesListSelectorSelector = (state) => state?.deviceType?.isLoading
export const deviceTypesListSelector = (state) => state?.deviceType?.list
export const deviceTypesDropdownListSelector = (state) => state?.deviceType?.list?.map(item => ({label: item?.deviceTypeName, value: item?.deviceTypeId}))


export const isLoadingDeviceTypesListIdsSelectorSelector = (state) => state?.deviceType?.isLoadingListIds
export const deviceTypesListIdsSelector = (state) => state?.deviceType?.listIds
export const deviceTypesDropdownListIdsSelector = (state) => state?.deviceType?.listIds?.map(item => ({label: item?.deviceTypeName, value: item?.deviceTypeId}))
